import { isFeatureEnabled } from '@wix/answers-experiments';
export var defaultTicketFilter = {
    statuses: isFeatureEnabled('OneInbox') ? undefined : [],
    priorities: [],
    channels: [],
    hasAllOfLabelIds: [],
    hasAnyOfLabelIds: [],
    notHasAnyOfLabelIds: [],
    assignedUserIds: [],
    assignedGroupIds: [],
    assignedByUserIds: [],
    handledByUserIds: [],
    assigned: null,
    assignedByMe: null,
    assignedToMe: null,
    assignedToMyGroups: null,
    assignedToAnyAgent: null,
    handledByMe: null,
    relatedArticleIds: [],
    countries: [],
    categoryId: null,
    ratingType: null,
    ratedUserIds: [],
    spam: false,
    hasAgentReply: null,
    fromHoursAgo: null,
    fromLastUpdateDate: null,
    toLastUpdateDate: null,
    fromCreationDate: null,
    toCreationDate: null,
    repliedByMe: null,
    repliedByUserIds: [],
    channelFilters: [],
    lastChannelFilters: [],
    callQueueIds: [],
    callLineIds: [],
    callStatuses: [],
    fromCallDurationSeconds: null,
    toCallDurationSeconds: null,
    fromCallWaitDurationSeconds: null,
    toCallWaitDurationSeconds: null,
    fromCallCreationDate: null,
    toCallCreationDate: null,
    callHandlingUserIds: null,
    callHandled: null,
    callHandledByMe: null,
    slaFilters: null,
    companyIds: null,
    userIds: null,
    hasRatings: null,
    ratings: [],
    currentlyHandled: null,
    myTickets: null,
    handled: null,
    myHandled: null,
    snooze: null,
    brandFilters: { brandId: undefined, brandless: false },
};
//# sourceMappingURL=ticket-filters.i.js.map